import { createRouter, createWebHistory } from 'vue-router'
import { useAccount } from '@/core/composables/useAccount';
// import { useAccountStore } from '@/core/store/accountStore';
import { roles } from '@/core/helper/enums/security/roles'
import CallbackView from '@/app/views/security/auth/CallbackView.vue'
import UnauthorizedView from '../views/security/UnauthorizedView.vue';
import ChatView from '@/app/views/ChatView.vue'
import ListView from '@/app/views/directory/contact/ListView.vue'
import UpdateView from '@/app/views/directory/contact/ListView.vue'
import ConfigurationView from '@/app/views/configuration/ConfigurationView.vue'
import ChannelMessagingView from '@/app/views/configuration/channel/MessagingView.vue'
import AIAgentView from '@/app/views/configuration/channel/AIAgentView.vue'
import WhatsappIntegrationListView from '@/app/views/configuration/channel/whatsapp/WhatsappIntegrationList.vue'
import WhatsappIntegrationCreateView from '@/app/views/configuration/channel/whatsapp/CreateWhatsappIntegration.vue'
import AnswerBotList from '../views/configuration/channel/AIAgent/answer/AnswerBotList.vue';
import AnswerBotCreate from '../views/configuration/channel/AIAgent/answer/CreateAnswerBot.vue';
import BrandView from '@/app/views/configuration/account/brand/BrandView.vue'
import BrandCreateView from '@/app/views/configuration/account/brand/CreateBrandView.vue'
import BrandUpdateView from '@/app/views/configuration/account/brand/BrandUpdateView.vue'


const routes = [
  {
    path: '/auth/unauthorized',
    name: 'unauthorized',
    component: UnauthorizedView
  },
  {
    path: '/chats',
    name: 'chat',
    component: ChatView,
    meta: {
      requiredAuth: true,
      roles: [
        roles.administrator.name
      ]
    },
  },
  {
    path: '/directory/contacts',
    name: 'contacts',
    component: ListView,
    meta: {
      requiredAuth: true,
      roles: [
        roles.administrator.name
      ]
    },
  },
  {
    path: '/directory/contacts/:guid',
    name: 'updateContact',
    component: UpdateView,
    meta: {
      requiredAuth: true,
      roles: [
        roles.administrator.name
      ]
    },
  },

  //CONFIGURATION
  {
    path: '/configurations',
    name: 'configuration',
    component: ConfigurationView,
    meta: {
      requiredAuth: true,
      roles: [
        roles.administrator.name
      ]
    },
  },
  {
    path: '/configuration/channel/messaging',
    name: 'channelMessaging',
    component: ChannelMessagingView,
    meta: {
      requiredAuth: true,
      roles: [
        roles.administrator.name
      ],
      modules: [
        'channels'
      ]
    },
  },
  {
    path: '/configuration/channel/whatsapp',
    name: 'configurationWhatsappList',
    component: WhatsappIntegrationListView,
    meta: {
      requiredAuth: true,
      roles: [
        roles.administrator.name
      ],
      modules: [
        'channels',
        'channelMessaging'
      ]
    },
  },
  {
    path: '/configuration/channel/whatsapp/setup',
    name: 'configurationWhatsappSetup',
    component: WhatsappIntegrationCreateView,
    meta: {
      requiredAuth: true,
      roles: [
        roles.administrator.name
      ],
      modules: [
        'channels',
        'channelMessaging'
      ]
    },
  },
  {
    path: '/configuration/channel/assistants',
    name: 'channelAIAgent',
    component: AIAgentView,
    meta: {
      requiredAuth: true,
      roles: [
        roles.administrator.name
      ],
      modules: [
        'channels',
      ]
    },
  },
  {
    path: '/configuration/answerbots',
    name: 'answerBotList',
    component: AnswerBotList,
    meta: {
      requiredAuth: true,
      roles: [
        roles.administrator.name
      ],
      modules: [
        'channels',
        'channelAIAgent'
      ]
    },
  },
  {
    path: '/configuration/answerbots/create/:guid',
    name: 'answerBotCreate',
    component: AnswerBotCreate,
    meta: {
      requiredAuth: true,
      roles: [
        roles.administrator.name
      ]
    },
  },
  //BRANDS
  {
    path: '/configuration/brands',
    name: 'brandView',
    component: BrandView,
    meta: {
      requiredAuth: true,
      roles: [
        roles.administrator.name
      ],
      modules: [
        'business'
      ]
    },
  },
  {
    path: '/configuration/brands/create',
    name: 'brandCreateView',
    component: BrandCreateView,
    meta: {
      requiredAuth: true,
      roles: [
        roles.administrator.name
      ],
      modules: [
        'business',
        'brandView'
      ]
    },
  },
  {
    path: '/configuration/brands/:guid',
    name: 'brandUpdateView',
    component: BrandUpdateView,
    meta: {
      requiredAuth: true,
      roles: [
        roles.administrator.name
      ],
      modules: [
        'business',
        'brandView'
      ]
    },
  },
  {
    path: '/callback',
    component: CallbackView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach(async (to, from, next) => {
  const { userManager } = useAccount();

  if (to.matched.some((record) => record.meta.requiredAuth)) {
    const user = await userManager.getUser();
    
    if(!user){
      userManager.signinRedirect({
        state: { target: to.fullPath },
      });

      return;
    }
  }
  return next();
});

// router.beforeEach(async (to, from, next) => {
//   const { userManager } = useAccount();
//   // const accountStore = useAccountStore();
//   // const isUserLoggedIn = accountStore.isLoggin;
//   // const currentUser = isUserLoggedIn ? await accountStore.getCurrentUser() : null;

//   const user = await userManager.getUser();
//   if (!user || user.expired) {
//     userManager.signinRedirect({
//       state: { target: to.fullPath },
//     });
//     return;
//   }

//   // if (to.name === 'login') {
//   //   if (currentUser) return next({ name: 'chat' });
//   //   else return next();
//   // }

//   // if (to.matched.some((record) => record.meta.requiredAuth)) {
//   //   if (isUserLoggedIn && currentUser) {
//   //     const hasRequiredRoles = !to.meta.roles || to.meta.roles.some((rol) => currentUser.roles.includes(rol)) || !(to.meta.roles.length > 0);
      
//   //     if (hasRequiredRoles) return next();
//   //     else return next({ name: 'unauthorized' });
//   //   } else {
//   //     return next({ name: 'login' });
//   //   }
//   // }

//   return next();
// });

export default router
